var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB7klEQVR4Ae3YAWQbYRiH8SEIgiIoiiIYhsNQBKEIimAYgqIIgiIoAhiKoBgKCIKgGGAoAgiCYAiGAIJDEQSHfx8AR7+7e7+TfOUefgCBy/u+575UVVWV3qXDBYLuN5ThAcG2hzJsEGTnUA4JgqwN5dRCcN1BOXVx1GqI4OoJymkEVxFK6wxbCBuM0Ez9dRZQQQtEqRl6wBbCGjV49wilHDDDE+QhwQQvSKCUIbxq4QCdyBuaMPcCndgzTF1DAUjwzbJ1/kGedoghTwvTTjdaoodGapP1sYGMesjdvfFR38NVDY+QQR+5axgGeGBezdmmqKNwIyRQhlfDjG2gDAfcwasOdpBDG0XrQw5bfEcp/XAfG1NnkMM1SmsAfWAFa/Gx3liH7rVpbmdam4ZuoQ/EsNSAHDoopQj/IYcIRetBDmtcwqtb7KEMcxRtCWWIrcNcw3P5p9506ROMLQdMBe3RQ1YDJFBBN8jdGDKaI0K6Nl4ho5/IXQM7yEOMJVZ4gzysYD/1AbiCqSV0YjOYu4JOaI8LeDWFkLbAX8jTHGsIaWN4d449hBgTfE0dO8vAr9FNPe0pDhC2qKOUmrhx/GAdMyinXxmv2T00cNSGUE5dBFf3s39eb0E5JAi2BMqwQbD9gTJMEGw1dBzaqKqqKrF3DNQYrK6wOS0AAAAASUVORK5CYII="
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "planning_blck",
    "data-name": "planning blck",
    width: 33,
    height: 33,
    fill: "url(#pattern)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.62bd8b6cfffb0862cc9742c6a03fa45d.svg";
export { ForwardRef as ReactComponent };